import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { useDispatch } from 'react-redux';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';

const changePlanEndDate = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/plan_end_date/${shutdownId}`,
    data,
    'Не удалось сохранить плановую дату окончания',
    'Error'
  );

  return res;
};

export const useShutdownPlanEndDateChange = (options = {}) => {
  const dispatch = useDispatch();

  const changeMutation = useMutation(changePlanEndDate, {
    ...options,
    onSuccess: (res, { shutdownId, data }) => {
      if (res !== 'Error') {
        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
